<template>
	<div class="full" style="box-sizing: border-box;">
		<vxe-table :data="invoiceaduit" size="mini" max-height="90%" border>
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="invoicetypecode" title="品类编码"></vxe-column>
			<vxe-column field="goodscode" title="规格编码"></vxe-column>
			<vxe-column field="invoicetype" title="品类类型"></vxe-column>
			<vxe-column field="invoicetypename" title="品类名称"></vxe-column>
			<vxe-column field="num" title="数量"></vxe-column>
			<vxe-column field="price" title="单价" ></vxe-column>
			<vxe-column field="amount" title="金额" ></vxe-column>
		</vxe-table>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			item: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				invoiceaduit: [],
			}
		},
		watch: {

		},
		computed: {

		},
		created() {
			this.invoiceaduit = this.item.invoiceaduit
		},
		mounted() {

		},
		methods: {
			formatter({cellValue}){
			
				return window.systemMethods.getEmunValue('invoiceaudittype', cellValue)
			}
		},
		components: {

		}
	}
</script>
